import { useState } from "react";

/* ================= Component ================= */

const WorkTemplateBuilder = () => {

  const [templates, setTemplates] = useState([
    { id: 1, name: "Internal Audit Template", type: "Audit" }
  ]);

  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);

  const [structure, setStructure] = useState([
    {
      id: 1,
      stageName: "Planning",
      areas: [
        {
          id: 11,
          areaName: "Purchase",
          subAreas: [
            {
              id: 111,
              subAreaName: "Expense Cutoff",
              checklist: [
                {
                  id: 1111,
                  title: "Verify Trial Balance",
                  mandatory: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]);

  /* ================= Add Functions ================= */

  const addStage = () => {
    setStructure([
      ...structure,
      {
        id: Date.now(),
        stageName: "New Stage",
        areas: []
      }
    ]);
  };

  const addArea = (stageId) => {
    setStructure(structure.map(stage =>
      stage.id === stageId
        ? {
            ...stage,
            areas: [
              ...stage.areas,
              {
                id: Date.now(),
                areaName: "New Area",
                subAreas: []
              }
            ]
          }
        : stage
    ));
  };

  const addSubArea = (stageId, areaId) => {
    setStructure(structure.map(stage =>
      stage.id === stageId
        ? {
            ...stage,
            areas: stage.areas.map(area =>
              area.id === areaId
                ? {
                    ...area,
                    subAreas: [
                      ...area.subAreas,
                      {
                        id: Date.now(),
                        subAreaName: "New Sub Area",
                        checklist: []
                      }
                    ]
                  }
                : area
            )
          }
        : stage
    ));
  };

  const addChecklist = (stageId, areaId, subAreaId) => {
    setStructure(structure.map(stage =>
      stage.id === stageId
        ? {
            ...stage,
            areas: stage.areas.map(area =>
              area.id === areaId
                ? {
                    ...area,
                    subAreas: area.subAreas.map(sub =>
                      sub.id === subAreaId
                        ? {
                            ...sub,
                            checklist: [
                              ...sub.checklist,
                              {
                                id: Date.now(),
                                title: "New Checklist Item",
                                mandatory: false
                              }
                            ]
                          }
                        : sub
                    )
                  }
                : area
            )
          }
        : stage
    ));
  };

  /* ================= UI ================= */

  return (
    <div className="grid grid-cols-12 gap-6 p-6 bg-slate-50 min-h-screen">

      {/* LEFT TEMPLATE LIST */}
      <div className="col-span-3 bg-white border border-slate-200 rounded-xl p-4">

        <h4 className="font-semibold mb-4">
          Templates
        </h4>

        {templates.map(t => (
          <div
            key={t.id}
            onClick={() => setSelectedTemplate(t)}
            className={`p-2 rounded cursor-pointer ${
              selectedTemplate.id === t.id
                ? "bg-indigo-600 text-white"
                : "hover:bg-slate-100"
            }`}
          >
            {t.name}
          </div>
        ))}

        <button
          className="mt-4 w-full bg-indigo-600 text-white rounded px-3 py-2 text-sm"
        >
          + New Template
        </button>

      </div>

      {/* RIGHT EDITOR */}
      <div className="col-span-9 space-y-6">

        <div className="bg-white border border-slate-200 rounded-xl p-5">

          <h2 className="text-xl font-semibold">
            {selectedTemplate.name}
          </h2>

          <p className="text-sm text-slate-500">
            Type: {selectedTemplate.type}
          </p>

        </div>

        {/* STRUCTURE */}
        {structure.map(stage => (

          <div
            key={stage.id}
            className="bg-white border border-slate-200 rounded-xl p-5 space-y-4"
          >

            <div className="flex justify-between items-center">
              <h3 className="font-semibold text-lg">
                {stage.stageName}
              </h3>

              <button
                onClick={() => addArea(stage.id)}
                className="text-sm text-indigo-600"
              >
                + Add Area
              </button>
            </div>

            {stage.areas.map(area => (

              <div
                key={area.id}
                className="ml-4 border-l-2 border-slate-200 pl-4 space-y-3"
              >

                <div className="flex justify-between">
                  <h4 className="font-medium">
                    {area.areaName}
                  </h4>

                  <button
                    onClick={() => addSubArea(stage.id, area.id)}
                    className="text-sm text-indigo-600"
                  >
                    + Add Sub Area
                  </button>
                </div>

                {area.subAreas.map(sub => (

                  <div
                    key={sub.id}
                    className="ml-4 border-l-2 border-slate-200 pl-4 space-y-2"
                  >

                    <div className="flex justify-between">
                      <h5 className="font-medium">
                        {sub.subAreaName}
                      </h5>

                      <button
                        onClick={() =>
                          addChecklist(stage.id, area.id, sub.id)
                        }
                        className="text-sm text-indigo-600"
                      >
                        + Add Checklist
                      </button>
                    </div>

                    {sub.checklist.map(c => (
                      <div
                        key={c.id}
                        className="ml-4 flex items-center justify-between"
                      >
                        <span>
                          {c.title}
                        </span>

                        <label className="text-sm flex items-center gap-1">
                          <input
                            type="checkbox"
                            checked={c.mandatory}
                            readOnly
                          />
                          Mandatory
                        </label>
                      </div>
                    ))}

                  </div>
                ))}

              </div>
            ))}

          </div>
        ))}

        <button
          onClick={addStage}
          className="bg-indigo-600 text-white px-4 py-2 rounded text-sm"
        >
          + Add Stage
        </button>

      </div>

    </div>
  );
};

export default WorkTemplateBuilder;
